module.exports = __webpack_public_path__ + "static/media/cold.954e5ef4.svg";